import { createApiRef } from '@backstage/core-plugin-api';

export type QualityGateOption = {
  id: number;
  name: string;
};

export type QualityGatesResponse = {
  qualityGates: QualityGateOption[];
  organization: string;
  instance: string;
};

export type SonarInstanceName = 'default' | 'github';

/**
 * API interface for SonarCloud Quality Gates
 */
export interface QualityGatesApi {
  /**
   * Fetch Quality Gates for a SonarCloud organization
   * @param organization - SonarCloud organization key
   * @param instance - SonarCloud instance name (`default` or `github`)
   */
  getQualityGates(
    organization: string,
    instance?: SonarInstanceName,
  ): Promise<QualityGatesResponse>;
}

/**
 * API reference for Quality Gates
 */
export const qualityGatesApiRef = createApiRef<QualityGatesApi>({
  id: 'plugin.quality-gates.service',
});
